import {gql} from '@apollo/client'

export const ChildCategoryFragment = gql`
    fragment ChildCategoryFields on ChildCategoryObject {
        idStr
        label
        profilesCount
        profiles {
            ...ProfileSortData
            ...ProfileComponentProfile
        }
    }
`
